module.exports = __webpack_public_path__ + "static/img/map0417.302feea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map0417.jpg
// module id = 2+tT
// module chunks = 0